
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_25476_41979)"}},[_c('path',{attrs:{"d":"M18.603 13.63l5.647-5.647V.924h-7.059l-5.647 5.647m7.059 7.06v5.646l-5.647 4.236-1.412-5.648m7.059-4.235l-7.059 4.236m0 0l-1.412 1.411H5.897v-4.235L7.31 13.63m4.235 4.236l2.824-7.06-7.06 2.824m0 0l-5.646-1.412 4.235-5.647h5.647m-4.235 7.06l4.235-7.06m7.059 0h.013M8.72 23.513l-1.412 1.411m-4.235-2.823l-1.412 1.412m0-7.06L.25 17.867","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41979"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.75 .424)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    